﻿import { Component, ContentChildren, Input, QueryList } from "@angular/core";
import { HorizontalTextBoxComponent } from "../shared/horizontaltextBox/horizontaltextBox.component";
import { TextBoxComponent } from "../shared/textBox/textBox.component";
import { ErrorObjName, ValidationBase } from "./validationBase";

@Component({
    selector: "jax-validation-form",
    template: "<ng-content></ng-content>",
})
export class ValidationFormComponent {
    private _iNotifyErrorObject: ValidationBase;
    private _isReadOnly;
    private _isDisabled;
    @ContentChildren(TextBoxComponent)
    elements: QueryList<TextBoxComponent>;

    @ContentChildren(HorizontalTextBoxComponent)
    helements: QueryList<HorizontalTextBoxComponent>;

    @Input()
    set iNotifyErrorObject(value) {
        if (value) {
            if (Object.prototype.hasOwnProperty.call(value, ErrorObjName)) {
                this._iNotifyErrorObject = value[ErrorObjName];
            }
            else {
                this._iNotifyErrorObject = value;
            }
        }
        if (this.elements || this.helements) {
            this.ngAfterContentInit();
        }
    }

    @Input()
    set isReadOnly(value) {
        this._isReadOnly = value;
        this.setElementsReadOnlyReadOnlyState();

    }

    @Input()
    set isDisabled(value) {
        this._isDisabled = value;
        this.setElementsDisabledState();
    }
    validate() {
     if (this.elements) {
            this.elements.forEach((s) => s.validateValue());
        }
        if (this.helements) {
            this.helements.forEach((s) => s.validateValue());
        }
    }

    ngAfterContentInit() {
        if (!(this.elements || this.helements)) {
            return;
        }
        this.elements.forEach(( s ) => {
            if (!this._iNotifyErrorObject) {
                return;
            }
            s.iNotifyErrorObject = this._iNotifyErrorObject;
            s.isDisabled = this._isDisabled;
            s.isReadOnly = this._isReadOnly;
        });

        this.helements.forEach(( s ) => {
            if (!this._iNotifyErrorObject) {
                return;
            }
            s.iNotifyErrorObject = this._iNotifyErrorObject;
            s.isDisabled = this._isDisabled;
            s.isReadOnly = this._isReadOnly;
        });

        this.bindValidateEvent();
        this.setElementsDisabledState();
        this.setElementsReadOnlyReadOnlyState();
    }

    private bindValidateEvent() {
        if (!this._iNotifyErrorObject) {
            return;
        }
        this._iNotifyErrorObject.onValidate.subscribe(( s ) => { this.elements.forEach(( p ) => p.validateValue()); this._iNotifyErrorObject.validationCompleted(); });
        this._iNotifyErrorObject.onValidate.subscribe(( s ) => { this.helements.forEach(( p ) => p.validateValue()); this._iNotifyErrorObject.validationCompleted(); });
    }

    setElementsDisabledState() {
        if (this.elements) {
            this.elements.forEach(( s ) => s.isDisabled = this._isDisabled);
        }

        if (this.helements) {
            this.helements.forEach(( s ) => s.isDisabled = this._isDisabled);
        }
    }

    setElementsReadOnlyReadOnlyState() {
        if (this.elements) {
            this.elements.forEach(( s ) => s.isReadOnly = this._isReadOnly);
        }
        if (this.helements) {
            this.helements.forEach(( s ) => s.isReadOnly = this._isReadOnly);
        }
    }
}
